import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import { pxToRem } from 'utils';

const UiIcon = forwardRef(
  (
    {
      src = '',
      extension = 'svg',
      style = {},
      className = '',
      icon,
      color = '#9CAEBB',
      hover,
      size = 16,
      disabled = false,
      ...other
    },
    ref
  ) => {
    const useStyles = makeStyles(() => ({
      icon: {
        color: disabled ? 'rgba(0, 0, 0, 0.26)' : color,
        fontSize: pxToRem(size),
        '&:hover': {
          color: disabled ? 'rgba(0, 0, 0, 0.26)' : hover || 'unset',
        },
      },
    }));
    const classes = useStyles();
    if (icon) {
      return (
        <i
          ref={ref}
          className={classNames('icon flex', className, icon, classes.icon)}
          style={style}
          {...other}
        />
      );
    }
    const address = src
      ? require(`./../../assets/icons/${src}.${extension}`)
      : null;
    return (
      <img
        ref={ref}
        className={classNames('icon', className)}
        src={address}
        style={style}
        {...other}
      />
    );
  }
);

UiIcon.displayName = 'UiIcon';

UiIcon.propTypes = {
  src: PropTypes.string,
  extension: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  hover: PropTypes.string,
  disabled: PropTypes.bool,
};

export default memo(UiIcon);
